import React from 'react';
import dayjs from 'dayjs';
import { createUseStyles } from 'react-jss';
import { IonButton, IonLabel } from '@ionic/react';
import { ChevronLeftIcon, ChevronRightIcon } from '../../theme/Icons';
import { ISO8601Month } from '../model/CheckinState';

const useStyles = createUseStyles({
    wrapper: {
        margin: '0 10px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    label: {
        fontSize: '20px',
        fontWeight: 700
    },
    button: {
        width: 48,
        height: 48,
        '--background-hover-opacity': '0.08'
    }
});

export interface IJournalNavProps {
    // month format is YYYY-MM
    month: ISO8601Month,
    onMonthChange: (month: ISO8601Month) => void;
}

export const JournalNav: React.FC<IJournalNavProps> = ({  month, onMonthChange }) => {

    const classes = useStyles();

    const currentMonth = dayjs().format('YYYY-MM');

    const getNewMonth = (delta: number) => {
        // transition mid-month (15th) so daylight saving can't push us into the wrong month
        return dayjs(month).date(15).add(delta, 'month').format('YYYY-MM');
    };

    return (
        <div className={classes.wrapper}>
            <IonLabel className={classes.label} data-id="journal-nav-caption">
                {dayjs(month).format('MMMM YYYY')}
            </IonLabel>

            <div>
                <IonButton
                    data-id="journal-nav-previous-button"
                    fill="clear"
                    shape="round"
                    className={classes.button}
                    onClick={() => onMonthChange(getNewMonth(-1))}
                >
                    <ChevronLeftIcon />
                </IonButton>

                <IonButton
                    data-id="journal-nav-next-button"
                    fill="clear"
                    shape="round"
                    className={classes.button}
                    disabled={month >= currentMonth}
                    onClick={() => onMonthChange(getNewMonth(1))}
                >
                    <ChevronRightIcon />
                </IonButton>
            </div>
        </div>
    );
};
